import React, { Component } from 'react';
import { isPhone } from '../utils/util';

export default class TopDom extends Component {
  render () {
    return (
      <div className="top-wrapper need-clear">
        {
          !!!isPhone() && 
          <div className="top-content">
            <a href="https://www.xfz.cn" target="_blank" rel="noopener noreferrer"><img src="https://static-image.xfz.cn/1694958512643/new_white_logo_2309.png" className="top-logo" alt="logo"></img></a>
            <ul className="location-item default-ul-style">
              <a href="https://www.xfz.cn/posts/" className="a-link margin-right-30" target="_blank" rel="noopener noreferrer">
                <li>
                  资讯
                </li>
              </a>
              <li className="shop-school">
                创业课堂
                <span className="triangle-down"></span>
                <div className="shop-school-content down-content">
                  <a href="https://www.xfz.cn/course/" target="_blank" rel="noopener noreferrer">在线课堂</a>
                  <a href="https://www.xfz.cn/events/" target="_blank" rel="noopener noreferrer">线下课堂</a>
                  <a href="https://www.xfz.cn/class/aclass/" target="_blank" rel="noopener noreferrer">A轮班</a>
                </div>
              </li>
              <li className="qi-service">
                企业服务
                <span className="triangle-down"></span>
                <div className="qi-service-content down-content">
                  <a href="https://www.xfz.cn/xfzgifts/" target="_blank" rel="noopener noreferrer">创业礼包</a>
                  <a href="https://www.xfz.cn/xfzresearch/" target="_blank" rel="noopener noreferrer">付费资讯</a>
                  <a href="https://www.xfz.cn/explore/" target="_blank" rel="noopener noreferrer">创投活动</a>
                </div>
              </li>
              <a href="https://www.xfz.cn/post/search/" className="a-link" target="_blank" rel="noopener noreferrer">
                <li>
                  搜索
                </li>
              </a>
            </ul>
          </div>
        }
        {
          isPhone() &&
          <div className="top-content">
            <a href="https://www.xfz.cn" target="_blank" rel="noopener noreferrer"><img src="https://static-image.xfz.cn/1694958512643/new_white_logo_2309.png" className="top-logo" alt="logo"></img></a>
            <ul className="location-item">
              <a href="https://www.xfz.cn/posts/" className="a-link margin-right-50" target="_blank" rel="noopener noreferrer">
                资讯
              </a>
              <a href="https://www.xfz.cn/posts/" className="a-link margin-right-50" target="_blank" rel="noopener noreferrer">
                创业课堂
              </a>
              <a href="https://www.xfz.cn/posts/" className="a-link margin-right-50" target="_blank" rel="noopener noreferrer">
                在线课堂
              </a>
            </ul>
          </div>
        }
      </div>
    )
  }
};

